import React from 'react';
import PropTypes from 'prop-types';
import { IMAGE_SIZES, ResponsiveImage } from '@web/molecules';
import { PillText } from '@web/atoms';
import {
  StyledHoverImageCard,
  ImageContainer,
  HoverImage,
  Header,
  BodyContainer,
  Body,
  BadgeContainer,
} from './styles.js';

export const HoverImageCard = ({
  header,
  image,
  hoverImage = null,
  body,
  badge = null,
  badgeVariant = 'dark',
  badgeIcon,
  badgeIconAlignment = 'left',
  level,
}) => {
  return (
    <StyledHoverImageCard>
      {badge && (
        <BadgeContainer>
          <PillText
            text={badge}
            variant={badgeVariant}
            icon={badgeIcon}
            iconAlignment={badgeIconAlignment}
          ></PillText>
        </BadgeContainer>
      )}

      <ImageContainer tabIndex={hoverImage ? 0 : -1}>
        <ResponsiveImage
          alt={image.alt}
          src={image.src}
          width={image.width}
          height={image.height}
          sizes={IMAGE_SIZES.cardCarousel}
        />

        {hoverImage && (
          <HoverImage>
            <ResponsiveImage
              alt={hoverImage.alt}
              src={hoverImage.src}
              width={image.width}
              height={image.height}
              sizes={IMAGE_SIZES.cardCarousel}
            />
          </HoverImage>
        )}
      </ImageContainer>
      <BodyContainer>
        <Header as={level}>{header}</Header>
        {body && <Body>{body}</Body>}
      </BodyContainer>
    </StyledHoverImageCard>
  );
};

HoverImageCard.displayName = 'HoverImageCard';

HoverImageCard.propTypes = {
  header: PropTypes.string.isRequired,
  body: PropTypes.node.isRequired,
  image: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    alt: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }).isRequired,
  hoverImage: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    alt: PropTypes.string.isRequired,
  }),
  badge: PropTypes.string,
  badgeVariant: PropTypes.string,
  badgeIcon: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  badgeIconAlignment: PropTypes.oneOf(['left', 'right']),
  level: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
};
